(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name crewSignInScreen.controller:CrewSignInScreenCtrl
   *
   * @description
   *
   */
  angular
    .module('crewSignInScreen')
    .controller('CrewSignInScreenCtrl', CrewSignInScreenCtrl);

  function CrewSignInScreenCtrl(crewSignInScreenService,$interval) {
    var vm = this;
    vm.ctrlName = 'CrewSignInScreenCtrl';
    vm.model = {
      crewSignInData : null
    }

    function loadCrewSignInData(){
     crewSignInScreenService.getCrewSignInScreenData(function (signIndata) {
       vm.model.crewSignInData = signIndata;
     },function () {
       console.log('Crew SignIn Screen Data Retrieval Error ');
     });
    }

    loadCrewSignInData();

   $interval(function(){
      loadCrewSignInData();
    }, 720000);



  }
}());
